var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-session-card-skeleton"},[_c('div',{staticClass:"card-icon"}),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-label"},[_c('div',{staticClass:"os-name"}),_c('div',{staticClass:"last-used"})]),_c('div',{staticClass:"card-text"}),_c('div',{staticClass:"card-text"})])])
}]

export { render, staticRenderFns }